import React, { Component } from "react";

import Tabs from "../../components/Tabs/Tabs";
import "../common.css";
import "./CustomerList.css";

import CustomerList from "./CustomerList";
import Staffs from "./Staffs";

export default class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultTab: "Customer",
      isCommercialStaff: this.props.userInfo?.user?.role.includes("Commercial"),
    };
  }

  componentDidMount() {
    this.setState({
      defaultTab:
        window.location.pathname === "/commercial/customer-list"
          ? "Customer"
          : "Commercial",
    });
    // this.retrieveEmployeeList();
  }

  render() {
    const isCommercialUserPath =
      window.location.pathname === "/commercial/customer-list" &&
      this.state.isCommercialStaff;
    const isGeneralUserPath =
      window.location.pathname === "/customer-list" &&
      !this.state.isCommercialStaff;
    return (
      <div className={"page"}>
        {this.state.isCommercialStaff && (
          <div className="text-start mb-2" style={{ fontSize: "14px" }}>
            <div>Store : {this.props.userInfo?.user.seller}</div>
            <div>Location : {this.props.userInfo?.user.store_location}</div>
          </div>
        )}

        {isGeneralUserPath && (
          <Tabs
            defaultTab={this.state.defaultTab}
            resetTab={() => this.setState({ defaultTab: undefined })}
          >
            <div label="Customer">
              <CustomerList
                protectedFetch={this.props.protectedFetch}
                selectedbrandID={this.props.selectedbrandID}
                role={this.props.userInfo.user.role}
                userInfo={this.props.userInfo?.user}
              />
            </div>
            <div label="Commercial">
              <Staffs
                protectedFetch={this.props.protectedFetch}
                selectedbrandID={this.props.selectedbrandID}
                userInfo={this.props.userInfo}
                role={this.props.userInfo.user.role}
                setDefaultTab={() =>
                  this.setState({ defaultTab: "Commercial" })
                }
                storeLocationId={this.props.userInfo?.user.store_location_id}
                isCommercial={true}
                location={this.props.location}
              />
            </div>
            <div label="Cin7">
              <Staffs
                protectedFetch={this.props.protectedFetch}
                selectedbrandID={this.props.selectedbrandID}
                userInfo={this.props.userInfo}
                role={this.props.userInfo.user.role}
                setDefaultTab={() => this.setState({ defaultTab: "Cin7" })}
                storeLocationId={this.props.userInfo?.user.store_location_id}
                isCin7={true}
                location={this.props.location}
              />
            </div>
            {["Admin", "Staff", "Commercial Admin"].includes(
              this.props?.userInfo?.user?.role
            ) ? (
              <div label="Approval">
                <Staffs
                  protectedFetch={this.props.protectedFetch}
                  selectedbrandID={this.props.selectedbrandID}
                  userInfo={this.props.userInfo}
                  role={this.props.userInfo.user.role}
                  setDefaultTab={() =>
                    this.setState({ defaultTab: "Approval" })
                  }
                  storeLocationId={this.props.userInfo?.user.store_location_id}
                  isApproval={true}
                  location={this.props.location}
                />
              </div>
            ) : null}
          </Tabs>
        )}
        {isCommercialUserPath && (
          <CustomerList
            protectedFetch={this.props.protectedFetch}
            selectedbrandID={this.props.selectedbrandID}
            role={this.props.userInfo.user.role}
            userInfo={this.props.userInfo?.user}
          />
        )}
        {window.location.pathname === "/commercial/staffs" &&
          this.state.isCommercialStaff && (
            <div className="border-2">
              <h4>Commercial</h4>
              <Staffs
                protectedFetch={this.props.protectedFetch}
                selectedbrandID={this.props.selectedbrandID}
                userInfo={this.props.userInfo}
                role={this.props.userInfo.user.role}
                setDefaultTab={() =>
                  this.setState({ defaultTab: "Commercial" })
                }
                storeLocationId={this.props.userInfo?.user.store_location_id}
                isUserCommercial={true}
                location={this.props.location}
              />
            </div>
          )}
      </div>
    );
  }
}
